import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import '../stylesheets/AdminKeypad.css';
class AdminKeypad extends Component {

    render() {
        const { AdminKey, isMobile } = this.props;
        return (
            <>
                <style type="text/css">
                    {`
                        .btn-flat {
                            background-color: purple;
                            color: white;
                        }

                        .btn-xxl {
                            // padding: 1rem 1.5rem;
                            // font-size: 1.2rem;
                            height: 5rem;
                            max-height: 5rem;
                        }
                    `}
                </style>

                <Row className="text-center">
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="reconciliation" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} size="xxl">
                            {isMobile ? AdminKey.Mobile.reconciliation : AdminKey.Desktop.reconciliation}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="emptyTerminalPrintBuffer" size="xxl" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)}>
                            {isMobile ? AdminKey.Mobile.emptyTerminalPrintBuffer : AdminKey.Desktop.emptyTerminalPrintBuffer}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" size="xxl" name="reportX" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)}>
                            {isMobile ? AdminKey.Mobile.reportX : AdminKey.Desktop.reportX}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" size="xxl" name="reportZ" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)}>
                            {isMobile ? AdminKey.Mobile.reportZ : AdminKey.Desktop.reportZ}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" size="xxl" name="balanceInquiry" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)}>
                            {isMobile ? AdminKey.Mobile.balanceInquiry : AdminKey.Desktop.balanceInquiry}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="sendOfflineTransactions" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} style={{ fontSize: '1rem' }} size="xxl">
                            {isMobile ? AdminKey.Mobile.sendOfflineTransactions : AdminKey.Desktop.sendOfflineTransactions}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="printStoredEotTransactions" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} style={{ fontSize: '1rem' }} size="xxl">
                            {isMobile ? AdminKey.Mobile.printStoredEotTransactions : AdminKey.Desktop.printStoredEotTransactions}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="printLatestTransactionReceipt" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} style={{ fontSize: '1rem' }} size="xxl">
                            {isMobile ? AdminKey.Mobile.printLatestTransactionReceipt : AdminKey.Desktop.printLatestTransactionReceipt}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="downloadSoftware" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} style={{ fontSize: '1rem' }} size="xxl">
                            {isMobile ? AdminKey.Mobile.downloadSoftware : AdminKey.Desktop.downloadSoftware}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="downloadDataset" onClick={e => this.props.onClick(e.target.name, AdminKey.Error)} style={{ fontSize: '1rem' }} size="xxl" >
                            {isMobile ? AdminKey.Mobile.downloadDataset : AdminKey.Desktop.downloadDataset}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" name="terminalInfo" onClick={e => this.props.getTerminalInfo(e.target.name)} style={{ fontSize: '1rem' }} size="xxl" >
                            {this.props.isMobile ? 'Terminal Info' : 'Terminal Details'}
                        </Button>
                    </Col>
                    <Col xs={4} sm={4} md={3} className={'custom-button-margin'}>
                        <Button block variant="outline-primary" disabled={true} style={{ fontSize: '1rem' }} size="xxl" name="12">
                            {this.props.isMobile ? 'Empty2' : 'Empty2'}
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}

export default AdminKeypad;